import { Circle, Home, PlusSquare, Users } from 'react-feather';

import { getUserProjSection, getAccessToken, axios, aesEncrypt } from 'utils/common';

class UserAdminService {
  getUserList() {
    const URL = `Users/List`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getUserDetail() {
    const URL = `Users/Detail`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  getProductList() {
    const URL = `Users/Sprod`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  getRoleList() {
    const URL = `Users/Role/List`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getProjList() {
    const URL = `usersmanage/UserProjs`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  getUserProjsRoles(userId) {
    const URL = `usersmanage/Admin/ProjRole`;

    return axios({
      method: 'get',
      params: { userId },
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  validateByUserName(userName) {
    const URL = `Users/Validation`;

    return axios({
      method: 'get',
      params: { userName },
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  postProjRoles(params) {
    // const {UserId, ProjUserRole} =
    const URL = `Users/Assignation`;
    return axios({
      method: 'post',
      url: URL,
      data: params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  resetPassword(data) {
    const URL = `Authenticate/ResetPassword`;

    return axios({
      method: 'post',
      url: URL,
      data: {
        UserName: data.UserName,
        Password: aesEncrypt(data.Password)
      }
    });
  }

  createUserDetail(data) {
    const URL = `Users/Registration`;

    return axios({
      method: 'post',
      url: URL,
      data: {
        ...data,
        Password: aesEncrypt(data.Password),
        ConfirmPassword: aesEncrypt(data.ConfirmPassword)
      },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  deleteUser(userId) {
    const URL = `usersmanage/Admin/Delete`;

    return axios({
      method: 'delete',
      url: URL,
      data: { userId },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }

  updateUserDetail(data) {
    const URL = `Users/Modification`;

    return axios({
      method: 'put',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
  getSectionList(prodid) {
    const URL = `Users/Section`;

    return axios({
      method: 'get',
      url: URL,
      params: { prodid },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
}
export const userAdminService = new UserAdminService();
